import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=3d4fd800"
import script from "./DefaultContainer.vue?vue&type=script&lang=js"
export * from "./DefaultContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports